class LogicError extends Error {
    constructor(code, msg) {
        super(msg);
        this.code = code;
    }
}

export const ErrorEnum = {
    NETWORK_ERR: new Error("network error"),
    SERVICE_ERR: new Error("service error"),
    AUTH_ERR: new Error("user has no access"),
    LOGIC_ERR: (code, msg) => new LogicError(code, msg)
}

export const SiteDesc = "说出需求,直达产品/游戏/工具/公司/工作/文章/视频/商品/新闻"
export const SiteKeywords = "AI搜索,搜索产品,搜索游戏,搜索公司,搜索文章,搜索视频,搜索商品,搜索新闻"


export function GenMetaTitle(t) {
    return `${t} - Reddo | AI搜索`
}
